/* eslint-disable camelcase */
window.pushQueueRequest = function pushQueueRequest(panelId, request) {
  const panel = window.getRealPannel(panelId);
  if (!panel) {
    return;
  }

  if (!Array.isArray(panel.request_queue)) {
    panel.request_queue = [];
    if (!Array.isArray(window.request_queues)) window.request_queues = [];
    let found = false;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < window.request_queues.length; i++) {
      if (window.request_queues[i] === panel.id) {
        found = true;
        break;
      }
    }
    if (!found) window.request_queues.push(panel.id);
  }
  panel.request_queue.push(request);
};

window.popQueueRequestAndProcess = function popQueueRequestAndProcess(panelId) {
  const panel = window.getRealPannel(panelId);
  if (!panel) {
    return;
  }

  if (!Array.isArray(panel.request_queue)) {
    panel.request_queue = [];
  }

  let group = false;

  while (panel.request_queue.length > 0) {
    const request = panel.request_queue.pop();

    if (request === 'group_end') break;
    if (request === 'group_start') {
      group = true;
      // eslint-disable-next-line no-continue
      continue;
    }

    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
    // eslint-disable-next-line no-eval
    eval(request);

    if (!group) break;
  }
};

window.clearAllRequestQueues = function clearAllRequestQueues() {
  if (!window || window.closing) return;
  if (!Array.isArray(window.request_queues)) return;
  if (!window.request_queues.length) return;
  if (window.request_queues.length < 1) return;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < window.request_queues.length; i++)
    window.clearRequestQueue(window.request_queues[i], true);
};

window.clearRequestQueue = function clearRequestQueue(pannel_id, recurse) {
  if (!pannel_id && !recurse) window.clearAllRequestQueues();

  const pannel = window.getRealPannel(pannel_id);

  if (!pannel && !recurse) window.clearAllRequestQueues();

  if (!pannel.request_queue) return;
  pannel.request_queue = [];
};

window.finishAjaxRequest = function finishAjaxRequest(pannel_id, result, callback) {
  if (result.requests) {
    if (result.requests.length > 0) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < result.requests.length; i++) {
        window.pushQueueRequest(pannel_id, result.requests[i]);
      }
    }
  }

  window.popQueueRequestAndProcess(pannel_id);
  if (typeof callback !== 'undefined') {
    callback();
  }
};
